import { useContext } from 'react';
import { QuotesContext } from './QuotesContextObject';

/**
 * Custom React hook to access the quotes context.
 *
 * @returns The current value of the `QuotesContext`.
 * @throws {Error} If the hook is used outside of a `QuoteDataProvider`.
 *
 * @example
 * const quoteContext = useQuoteContext();
 */
export function useQuoteContext() {
  const context = useContext(QuotesContext);
  if (context === undefined) {
    throw new Error('useQuoteContext must be used within a QuoteDataProvider');
  }
  return context;
}
